import { render, staticRenderFns } from "./TestimonialNote.vue?vue&type=template&id=816d2df8"
import script from "./TestimonialNote.vue?vue&type=script&lang=js"
export * from "./TestimonialNote.vue?vue&type=script&lang=js"
import style0 from "./TestimonialNote.vue?vue&type=style&index=0&id=816d2df8&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports